import { SkillData } from "types/battle-engine/battle";
import {
  DRAIN_PUNCH,
  BOULDER_BASH,
  STUN_SPORE,
  KINESIS,
  FLOWER_RUSH,
  POWER_WHIP,
  QUICK_TEMPO,
  SYNCHRONIZE,
  GEAR_UP,
  AGILITY,
  MAGNET_PULL,
  ROCK_TOMB,
  CHILLY_RECEPTION,
  SEISMIC_TOSS,
  INNER_SPIRIT,
  VINE_WHIP,
  PRISMATIC_CAGE,
  RAZOR_LEAF,
  EMBER,
  BUBBLE,
  THUNDER_SHOCK,
  ICE_SHARD,
  ACID,
  MUD_SHOT,
  GUST,
  PSY_BALL,
  BUG_BUZZ,
  ROCK_THROW,
  SHADOW_DAGGER,
  SCALE_SHOT,
  DARK_PULSE,
  SCRAP_THROW,
  SWEET_KISS,
  TACKLE,
  FIRE_PUNCH,
  AQUA_TAIL,
  BRANCH_POKE,
  THUNDER_PUNCH,
  ICE_PUNCH,
  KARATE_CHOP,
  POISON_JAB,
  MUD_SLAP,
  PECK,
  ZEN_HEADBUTT,
  POUNCE,
  ROCK_SMASH,
  LICK,
  DRAGON_CLAW,
  BITE,
  METAL_CLAW,
  PLAY_ROUGH,
  SCRATCH,
  HEADBUTT,
  SUPERSONIC,
  FIRE_BALL,
  BUBBLE_BEAM,
  BULLET_SEED,
  THUNDERBOLT,
  ICICLE_DAGGER,
  SLUDGE_BOMB,
  MUD_BOMB,
  CHATTER,
  PSY_PULSE,
  STRING_SHOT,
  ROCK_SLIDE,
  SHADOW_BALL,
  DRAGON_PULSE,
  FLATTER,
  MAGNET_BOMB,
  DAZZLING_GLEAM,
  ENERGY_BALL,
  CONFUSE_RAY,
  BODY_SLAM,
  FIRE_FANG,
  AQUA_CUTTER,
  WOOD_HAMMER,
  THUNDER_FANG,
  ICE_FANG,
  DOUBLE_KICK,
  POISON_FANG,
  EARTH_POWER,
  AIR_SLASH,
  PSYCHIC_FANGS,
  BUG_BITE,
  STONE_AXE,
  SHADOW_CLAWS,
  DRAGON_FANG,
  CRUNCH,
  BEHEMOTH_BASH,
  SPIRIT_BREAK,
  ERUPTION,
  HYDRO_PUMP,
  FRENZY_PLANT,
  THUNDER,
  HAILSTORM,
  SUPERPOWER,
  MORTAL_GAS,
  MAGNITUDE,
  AERIAL_ACE,
  PSYCHIC,
  INFEST,
  ANCIENT_POWER,
  NIGHT_SHADE,
  DRACO_METEOR,
  QUASH,
  METEOR_MASH,
  STARFALL,
  FIRE_SPIN,
  WHIRLPOOL,
  LEAF_TORNADO,
  WILD_CHARGE,
  AVALANCHE,
  POISON_GAS,
  EARTHQUAKE,
  ACROBATICS,
  PSYCHIC_TERRAIN,
  ROLLING_KICK,
  NIGHT_SLASH,
  METAL_SOUND,
  MIST_TERRAIN,
  PROTECT,
  SPLASH,
  LEER,
  GROWL,
  SCARY_FACE,
  SUNNY_DAY,
  PIN_MISSILE,
  PIN_RUSH,
  FLARE_BLITZ,
  CLOSE_COMBAT,
  CROSS_CHOP,
  SOUL_SACRIFICE,
  DARK_BARGAIN,
  TOXIC_OVERLOAD,
  OUTRAGE,
  METAL_RUSH,
  LIQUIDATION,
  VOLT_CRASH,
  SHEER_COLD,
  HEAL_BELL,
  SYNTHESIS,
  CALM_MIND,
  PURIFICATION,
  SPECTRAL_SNATCH,
  SNATCH,
  LEECH_STEAL,
  POWER_SIPHON,
  IRON_DEFENSE,
  TRI_ATTACK,
  BONE_THROW,
  BONEMERANG,
  POISON_POWDER,
  GUARDIAN_BOND,
  SPECTRAL_CHAIN,
  DRAGON_VORTEX,
  ROCK_BLAST,
  ICE_WAVE,
  VACUUM_WAVE,
  SOLAR_BEAM,
  FLAMETHROWER,
  BRINE,
  ZAP_CANNON,
  TOXIC_SPIKES,
  HURRICANE,
  PSYWAVE,
  PHANTOM_FORCE,
  DRAGON_BREATH,
  LASH_OUT,
  HYPER_VOICE,
  STEEL_BEAM,
  QUICK_ATTACK,
  BLAZE_KICK,
  AQUA_JET,
  VOLT_SWITCH,
  SANDSTORM,
  JUMP_KICK,
  BRAVE_BIRD,
  LUNGE,
  SHADOW_SNEAK,
  DRAGON_RUSH,
  PURSUIT,
  SMART_STRIKE,
  REFRESH,
  MORNING_SUN,
  LIFE_DEW,
  AROMATHERAPY,
  COACHING,
  PURIFY,
  ROOST,
  HEALING_WISH,
  HEAL_ORDER,
  MOONLIGHT,
  RAIN_DANCE,
  GRASSY_TERRAIN,
  ELECTRIC_TERRAIN,
  AURORA_VEIL,
  REFLECT,
  BULK_UP,
  VENOM_DRENCH,
  ROTOTILLER,
  TAILWIND,
  STICKY_WEB,
  STEALTH_ROCK,
  CURSE,
  DRAGON_DANCE,
  SNARL,
  GEAR_GRIND,
  MISTY_TERRAIN,
  MAGMA_STORM,
  WATER_SPOUT,
  OVERGROWTH,
  ELECTRIC_WRATH,
  BLIZZARD,
  METEOR_ASSAULT,
  ACID_RAIN,
  FISSURE,
  SKY_ATTACK,
  FUTURE_SIGHT,
  SIGNAL_SPAM,
  STONE_CRUSH,
  POLTERGEIST,
  GREAT_ROAR,
  NIGHT_DAZE,
  METAL_BURST,
  MOONBLAST,
} from "./data/index";

// All skills registry
export const POKEMON_SKILLS: Record<string, SkillData> = {
  "drain-punch": DRAIN_PUNCH!,
  "boulder-bash": BOULDER_BASH!,
  "stun-spore": STUN_SPORE!,
  kinesis: KINESIS!,
  "flower-rush": FLOWER_RUSH!,
  "power-whip": POWER_WHIP!,
  "quick-tempo": QUICK_TEMPO!,
  synchronize: SYNCHRONIZE!,
  "gear-up": GEAR_UP!,
  agility: AGILITY!,
  "magnet-pull": MAGNET_PULL!,
  "rock-tomb": ROCK_TOMB!,
  "chilly-reception": CHILLY_RECEPTION!,
  "seismic-toss": SEISMIC_TOSS!,
  "inner-spirit": INNER_SPIRIT!,
  "vine-whip": VINE_WHIP!,

  protect: PROTECT,
  splash: SPLASH, // The famous useless move
  // new ai skills
  "prismatic-cage": PRISMATIC_CAGE,
  // Simple Projectile Skills
  "razor-leaf": RAZOR_LEAF!,
  ember: EMBER!,
  bubble: BUBBLE!,
  "thunder-shock": THUNDER_SHOCK!,
  "ice-shard": ICE_SHARD!,
  acid: ACID!,
  "mud-shot": MUD_SHOT!,
  gust: GUST!,
  "psy-ball": PSY_BALL!,
  "bug-buzz": BUG_BUZZ!,
  "rock-throw": ROCK_THROW!,
  "shadow-dagger": SHADOW_DAGGER!,
  "scale-shot": SCALE_SHOT!,
  "dark-pulse": DARK_PULSE!,
  "scrap-throw": SCRAP_THROW!,
  "sweet-kiss": SWEET_KISS!,

  // Simple Melee Skills
  tackle: TACKLE!,
  "fire-punch": FIRE_PUNCH!,
  "aqua-tail": AQUA_TAIL!,
  "branch-poke": BRANCH_POKE!,
  "thunder-punch": THUNDER_PUNCH!,
  "ice-punch": ICE_PUNCH!,
  "karate-chop": KARATE_CHOP!,
  "poison-jab": POISON_JAB!,
  "mud-slap": MUD_SLAP!,
  peck: PECK!,
  "zen-headbutt": ZEN_HEADBUTT!,
  pounce: POUNCE!,
  "rock-smash": ROCK_SMASH!,
  lick: LICK!,
  "dragon-claw": DRAGON_CLAW!,
  bite: BITE!,
  "metal-claw": METAL_CLAW!,
  "play-rough": PLAY_ROUGH!,
  scratch: SCRATCH!,
  headbutt: HEADBUTT!,

  // Projectile Plus Skills
  supersonic: SUPERSONIC!,
  "fire-ball": FIRE_BALL!,
  "bubble-beam": BUBBLE_BEAM!,
  "bullet-seed": BULLET_SEED!,
  thunderbolt: THUNDERBOLT!,
  "icicle-dagger": ICICLE_DAGGER!,
  "sludge-bomb": SLUDGE_BOMB!,
  "mud-bomb": MUD_BOMB!,
  chatter: CHATTER!,
  "psy-pulse": PSY_PULSE!,
  "string-shot": STRING_SHOT!,
  "rock-slide": ROCK_SLIDE!,
  "shadow-ball": SHADOW_BALL!,
  "dragon-pulse": DRAGON_PULSE!,
  flatter: FLATTER!,
  "magnet-bomb": MAGNET_BOMB!,
  "dazzling-gleam": DAZZLING_GLEAM!,
  "energy-ball": ENERGY_BALL!,
  "confuse-ray": CONFUSE_RAY!,

  // Melee Plus Skills
  "body-slam": BODY_SLAM!,
  "fire-fang": FIRE_FANG!,
  "aqua-cutter": AQUA_CUTTER!,
  "wood-hammer": WOOD_HAMMER!,
  "thunder-fang": THUNDER_FANG!,
  "ice-fang": ICE_FANG!,
  "double-kick": DOUBLE_KICK!,
  "poison-fang": POISON_FANG!,
  "earth-power": EARTH_POWER!,
  "air-slash": AIR_SLASH!,
  "psychic-fangs": PSYCHIC_FANGS!,
  "bug-bite": BUG_BITE!,
  "stone-axe": STONE_AXE!,
  "shadow-claws": SHADOW_CLAWS!,
  "dragon-fang": DRAGON_FANG!,
  crunch: CRUNCH!,
  "behemoth-bash": BEHEMOTH_BASH!,
  "spirit-break": SPIRIT_BREAK!,

  // Big AOE and Rain Skills
  eruption: ERUPTION!,
  "hydro-pump": HYDRO_PUMP!,
  "frenzy-plant": FRENZY_PLANT!,
  thunder: THUNDER!,
  hailstorm: HAILSTORM!,
  superpower: SUPERPOWER!,
  "mortal-gas": MORTAL_GAS!,
  magnitude: MAGNITUDE!,
  "aerial-ace": AERIAL_ACE!,
  psychic: PSYCHIC!,
  infest: INFEST!,
  "ancient-power": ANCIENT_POWER!,
  "night-shade": NIGHT_SHADE!,
  "draco-meteor": DRACO_METEOR!,
  quash: QUASH!,
  "meteor-mash": METEOR_MASH!,
  starfall: STARFALL!,
  sandstorm: SANDSTORM!,

  // AOE Multihit and Spin Skills
  "fire-spin": FIRE_SPIN!,
  whirlpool: WHIRLPOOL!,
  "leaf-tornado": LEAF_TORNADO!,
  "wild-charge": WILD_CHARGE!,
  avalanche: AVALANCHE!,
  "poison-gas": POISON_GAS!,
  earthquake: EARTHQUAKE!,
  acrobatics: ACROBATICS!,
  "psychic-terrain": PSYCHIC_TERRAIN!,
  "rolling-kick": ROLLING_KICK!,
  "night-slash": NIGHT_SLASH!,
  "metal-sound": METAL_SOUND!,
  "mist-terrain": MIST_TERRAIN!,

  // Frontal Waves
  "rock-blast": ROCK_BLAST!,
  "ice-wave": ICE_WAVE!,
  "vacuum-wave": VACUUM_WAVE!,
  "solar-beam": SOLAR_BEAM!,

  // Frontal Beams
  flamethrower: FLAMETHROWER!,
  brine: BRINE!,
  "zap-cannon": ZAP_CANNON!,
  "toxic-spikes": TOXIC_SPIKES!,
  hurricane: HURRICANE!,
  psywave: PSYWAVE!,
  "phantom-force": PHANTOM_FORCE!,
  "dragon-breath": DRAGON_BREATH!,
  "lash-out": LASH_OUT!,
  "hyper-voice": HYPER_VOICE!,
  "steel-beam": STEEL_BEAM!,

  // Gap Closers
  "quick-attack": QUICK_ATTACK!,
  "blaze-kick": BLAZE_KICK!,
  "aqua-jet": AQUA_JET!,
  "volt-switch": VOLT_SWITCH!,
  "jump-kick": JUMP_KICK!,
  "brave-bird": BRAVE_BIRD!,
  lunge: LUNGE!,
  "shadow-sneak": SHADOW_SNEAK!,
  "dragon-rush": DRAGON_RUSH!,
  pursuit: PURSUIT!,
  "smart-strike": SMART_STRIKE!,

  // Healing Skills
  refresh: REFRESH!,
  "morning-sun": MORNING_SUN!,
  "life-dew": LIFE_DEW!,
  aromatherapy: AROMATHERAPY!,
  coaching: COACHING!,
  purify: PURIFY!,
  roost: ROOST!,
  "healing-wish": HEALING_WISH!,
  "heal-order": HEAL_ORDER!,
  moonlight: MOONLIGHT!,

  // Global Buff/Debuff Skills
  leer: LEER!,
  growl: GROWL!,
  "scary-face": SCARY_FACE!,
  "sunny-day": SUNNY_DAY!,

  // AI-Generated Global Effect Spells
  "rain-dance": RAIN_DANCE!,
  "grassy-terrain": GRASSY_TERRAIN!,
  "electric-terrain": ELECTRIC_TERRAIN!,
  "aurora-veil": AURORA_VEIL!,
  reflect: REFLECT!,
  "bulk-up": BULK_UP!,
  "venom-drench": VENOM_DRENCH!,
  rototiller: ROTOTILLER!,
  tailwind: TAILWIND!,
  "sticky-web": STICKY_WEB!,
  "stealth-rock": STEALTH_ROCK!,
  curse: CURSE!,
  "dragon-dance": DRAGON_DANCE!,
  snarl: SNARL!,
  "gear-grind": GEAR_GRIND!,
  "misty-terrain": MISTY_TERRAIN!,

  // Particle Emission Skills
  "pin-missile": PIN_MISSILE!,
  "pin-rush": PIN_RUSH!,
  // ----

  // Global Skills
  "magma-storm": MAGMA_STORM!,
  "water-spout": WATER_SPOUT!,
  overgrowth: OVERGROWTH!,
  "electric-wrath": ELECTRIC_WRATH!,
  blizzard: BLIZZARD!,
  "meteor-assault": METEOR_ASSAULT!,
  "acid-rain": ACID_RAIN!,
  fissure: FISSURE!,
  "sky-attack": SKY_ATTACK!,
  "future-sight": FUTURE_SIGHT!,
  "signal-spam": SIGNAL_SPAM!,
  "stone-crush": STONE_CRUSH!,
  poltergeist: POLTERGEIST!,
  "great-roar": GREAT_ROAR!,
  "night-daze": NIGHT_DAZE!,
  "metal-burst": METAL_BURST!,
  moonblast: MOONBLAST!,

  // Tactical Skills - Sacrifice/Recoil
  "flare-blitz": FLARE_BLITZ,
  "close-combat": CLOSE_COMBAT,
  "cross-chop": CROSS_CHOP!,
  "soul-sacrifice": SOUL_SACRIFICE,
  "dark-bargain": DARK_BARGAIN,
  "toxic-overload": TOXIC_OVERLOAD,

  // Tactical Skills - Conditional/Execute
  outrage: OUTRAGE,
  "metal-rush": METAL_RUSH,
  liquidation: LIQUIDATION,
  "volt-crash": VOLT_CRASH,
  "sheer-cold": SHEER_COLD,

  // Tactical Skills - Cleanse/Purify
  "heal-bell": HEAL_BELL,
  synthesis: SYNTHESIS,
  "calm-mind": CALM_MIND,
  purification: PURIFICATION,

  // Tactical Skills - Buff Steal
  "spectral-snatch": SPECTRAL_SNATCH,
  snatch: SNATCH,
  "leech-steal": LEECH_STEAL,
  "power-siphon": POWER_SIPHON,

  // More unique skills
  "iron-defense": IRON_DEFENSE!,
  "tri-attack": TRI_ATTACK!,
  "bone-throw": BONE_THROW!,
  bonemerang: BONEMERANG!,
  "poison-powder": POISON_POWDER!,

  // New Mechanic Skills
  "guardian-bond": GUARDIAN_BOND!,
  "spectral-chain": SPECTRAL_CHAIN!,
  "dragon-vortex": DRAGON_VORTEX!,
} as const;
